module.exports = __webpack_public_path__ + "img/suanneng.c92284f9.png";